import $ from "jquery"

// when the page load, activate the sticky footer
window.addEventListener("load", activateStickyFooter);

function activateStickyFooter() {
    adjustFooterCssTopToSticky();
    window.addEventListener("resize", adjustFooterCssTopToSticky);
}

function adjustFooterCssTopToSticky() {
    if ($(".footer")) {
        const footer = $(".footer")[0];
        try {
            const bounding_box = footer.getBoundingClientRect();
            const footer_height = bounding_box.height;
            const window_height = window.innerHeight;

            const above_footer_height = bounding_box.top - getCssTopAttribute(footer);
        
            if (above_footer_height + footer_height <= window_height) {
                const new_footer_top = window_height - (above_footer_height + footer_height);
                footer.style.top = new_footer_top + "px";
            } else if (above_footer_height + footer_height > window_height) {
                footer.style.top = null;
            }
        } catch (error) {
            
        }
    }
}

function getCssTopAttribute(htmlElement) {
    const top_string = htmlElement.style.top;
    if (top_string === null || top_string.length === 0) {
        return 0;
    }
    // assume this is written in pixels
    const extracted_top_pixels = top_string.substring(0, top_string.length - 2);
    return parseFloat(extracted_top_pixels);
}


/**
 * Scripts for redirecting to its corresponding anchor sections
 */
const brandLogoItem = $('.js-brand-logo .brands__logo-item');
const brandSection = $('#section--brands');
const policyAccordionItem = $('.section--accordion .accordion-item');
const document = $('html, body');

$(window).on('load', function() {
    const hash = window.location.hash.substring(1);

    if (hash) {
        if (brandSection.length) {
            scrollToBrand(hash);
        } else {
            scrollToPrivacyAccordionItem(hash);
        }
    }
});

brandLogoItem.on('click', function() {
    history.pushState({}, '',  '#'+$(this).data('anchor'));
});

policyAccordionItem.on('click', function() {
    history.pushState({}, '',  '#'+$(this).data('anchor'));
});

$('.footer__main .menu-item').on('click', function() {
    const title = $(this).find('a').attr('title');
    
    if (title == 'general-terms-and-conditions'){
        scrollToPrivacyAccordionItem(title);
    }
});

function scrollToBrand(target) {
    document.animate({
        scrollTop: brandSection.offset().top - 110
    }, 0);
    brandLogoItem.data('anchor', target).closest('.slick-slide').trigger('click')
}

function scrollToPrivacyAccordionItem(target) {
    const accordionItem = $('.section--accordion .accordion-item[data-anchor="'+target+'"]');
    if(accordionItem.length > 0) {
        document.animate({
            scrollTop: accordionItem.offset().top - 90
        }, 0);
        accordionItem.find('.accordion-button').trigger('click');
    }
}

// Single careers page footer nav item change to careers page active
$('.footer__top-menu li a').each(function(){
    const menuFooterItemLink = $(this).text();

    $('.footer__top-menu li').removeClass('current_page_parent');

    if(menuFooterItemLink == 'Careers'){
        $(this).closest('.menu-item').addClass('current_page_parent');
    }
});

/**
 * Task #1116:#1116: [UI]Services links placement
 * https://todo.createit.com/my-work?modal=Task-153690-1213
 */
$(".footer__menu li.menu-item-has-children .sub-menu").each(function() {
    let items = $(this).children('li');
    let listWrapper = $("<div class='sub-menu-list'></div>");
    let listHeading = $("<div class='sub-menu-heading'><a href='" + $(this).prev('a').attr('href') + "'>" + $(this).prev('a').text() + "</a><span class='sub-menu-trigger'></span></div>");

    for (let i = 0; i < items.length; i += 9) {
        let group = items.slice(i, i + 9);
        let innerWrapper = $("<div class='sub-menu-inner'></div>").append(group);
        listWrapper.append(innerWrapper);
    }

    $(this).append(listHeading).append(listWrapper);
});

$(window).on('load', function(){
    $(".footer__menu li > a").each(function(){
        var anchorWidth = $(this).width() + 16;
    
        $(this).next('.sub-menu').css('left' , anchorWidth);
    });
});

$('body').on('click', '.sub-menu-trigger', function() {
    $(this).closest('.sub-menu-heading').toggleClass('is-toggled');
});


/**
 * Task #1266:#1266: 13 [WCAG] Add return-to-top link
 */
const scrollButtons = $('.js-scroll-to-top a');

scrollButtons.on('click', function (e) {
  e.preventDefault();

  // Smooth scroll to top
  $('html, body').animate({ scrollTop: 0 }, 500, function () {
    // After scrolling, move focus to the top anchor
    $('#top-anchor').attr('aria-hidden', 'false').focus();
  });
});